"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleNotifications = exports.TOGGLE_NOTIFICATIONS = void 0;

var _createAction = require("../../skybase-core/base/create-action");

var _getActionName = require("../../skybase-core/utils/get-action-name");

var MODULE_NAME = 'skybase-ui';
var TOGGLE_NOTIFICATIONS = (0, _getActionName.getActionName)('TOGGLE_NOTIFICATIONS', MODULE_NAME);
exports.TOGGLE_NOTIFICATIONS = TOGGLE_NOTIFICATIONS;

var toggleNotifications = function toggleNotifications() {
  return (0, _createAction.createAction)(TOGGLE_NOTIFICATIONS, {});
};

exports.toggleNotifications = toggleNotifications;
//# sourceMappingURL=actions.js.map